import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EQueryStringActionType {
  SetQueryString = 'queryString/setQueryString',
}

export type TSetQueryString = ITypedReduxAction<EQueryStringActionType.SetQueryString, string>;

export type TQueryStringActions = TSetQueryString;
